export default __webpack_public_path__ + "static/static-asset-no-credit-check-data-32e0360e1850a88be98ee6520a16eca0.svg";